import * as t from 'ts-schema';
const HubSpotWindowSchema = t.object({
  sessionId: t.string,
  bender: t.object({
    currentProject: t.optional(t.string)
  })
});
export const getHubSpotWindowInfo = win => {
  if (t.validate(HubSpotWindowSchema, win.hubspot)) {
    var _win$hubspot$bender$c;
    return {
      sessionId: win.hubspot.sessionId,
      benderProject: (_win$hubspot$bender$c = win.hubspot.bender.currentProject) !== null && _win$hubspot$bender$c !== void 0 ? _win$hubspot$bender$c : undefined
    };
  }
  return undefined;
};